@layer ui-kit;
@layer ui-kit {
  .m0j9fx3 {
    display: flex;
    align-items: center;
    background-color: var(--m0j9fx0);
    width: fit-content;
    padding: 0;
  }
  .m0j9fx4 {
    --m0j9fx0: var(--_1qu8za2b);
    --m0j9fx1: var(--_1qu8za2c);
    --m0j9fx2: var(--_1qu8za22);
  }
  .m0j9fx5 {
    --m0j9fx0: var(--_1qu8za2d);
    --m0j9fx1: var(--_1qu8za2e);
    --m0j9fx2: var(--_1qu8za22);
  }
  .m0j9fx6 {
    border-radius: 8px;
  }
  .m0j9fx7 {
    border-radius: 4px;
  }
  .m0j9fx8 {
    cursor: pointer;
    background-color: transparent;
    color: var(--_1qu8za24);
    user-select: none;
    transition: .15s;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
  }
  .m0j9fx8:hover {
    color: var(--_1qu8za23);
  }
  .m0j9fx8:where([aria-checked="true"], .m0j9fx8[aria-pressed="true"]), .m0j9fx8:where([aria-checked="true"], .m0j9fx8[aria-pressed="true"]):hover {
    background-color: var(--m0j9fx1);
    border: 1px solid var(--m0j9fx2);
    color: var(--_1qu8za23);
  }
  .m0j9fx9 {
    font-weight: 400;
    font-size: 12px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    border-radius: 8px;
    padding: 8px 20px;
    height: 32px;
  }
  .m0j9fxa {
    font-weight: 500;
    font-size: 12px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    border-radius: 4px;
    padding: 4px 12px;
    height: 24px;
  }
}